<template>
  <div id="app">
    <router-view/>
    <BackToTop />
    <GlobalLoading />

    <!-- 全局安全卫士按钮 - 固定在返回顶部按钮上方 -->
    <a
      class="floating-logo"
      @click="openEwmModal"
    >
    </a>

    <!-- 鼠标跟随吉祥物 -->
    <div
      ref="mouseFollower"
      class="mouse-follower-mascot"
    ></div>
    
    <!-- 应急智能体聊天模态框 -->
    <div v-if="ewmModalVisible" class="ewm-modal-overlay" @click="closeEwmModal">
      <div class="ewm-modal" @click.stop>
        <div class="ewm-modal-header">
          <h3>应急智能体</h3>
          <button class="close-btn" @click="closeEwmModal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="ewm-modal-content">
          <!-- 首次加载提示 -->
          <div v-if="isFirstTimeOpen && iframeLoading" class="loading-tip">
            <i class="fas fa-spinner fa-spin"></i>
            <p>初次加载速度缓慢，请耐心等待...</p>
          </div>
          <iframe 
            ref="chatIframe"
            src="https://chatwork.appa.a111a.cn/chat/web-9a2360a0eb31e3ba7a27f208fd3351c3P3c0X"
            class="chat-iframe"
            frameborder="0"
            allowfullscreen
            title="应急智能体聊天"
            @load="handleIframeLoad"
          ></iframe>
        </div>
      </div>
    </div>

    <el-dialog
      :title="svModalConfig.modal_title || '服务'"
      :visible.sync="svModalVisible"
      width="520px"
      :close-on-click-modal="true"
      :append-to-body="true"
      :modal-append-to-body="true"
      custom-class="service-modal-dialog"
      @close="closeServiceModal"
    >
      <div v-loading="svModalLoading" class="service-modal-content">
        <div
          class="service-modal-body"
          v-html="formatSvModalContent(svModalConfig.modal_content)"
        ></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goToSvServicePage">前往</el-button>
        <el-button @click="closeServiceModal">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BackToTop from '@/components/BackToTop.vue'
import GlobalLoading from '@/components/GlobalLoading.vue'
import request from '@/utils/request'
import { svClickAPI } from '@/utils/api'
import apiOptimizer from '@/utils/api-optimizer'
import dataPrefetcher from '@/utils/data-prefetch'
import loadingManager from '@/utils/loading-manager'

export default {
  name: 'App',
  components: {
    BackToTop,
    GlobalLoading
  },
  data() {
    return {
      heartbeatTimer: null,
      // 安全卫士按钮相关数据
      ewmModalVisible: false,
      isFirstTimeOpen: true,  // 是否是第一次打开智能体
      iframeLoading: false,  // iframe是否正在加载
      // 全局状态
      globalLoadingState: null,  // 全局加载状态
      svModalVisible: false,
      svModalLoading: false,
      svModalConfig: {
        modal_title: '企业数字化服务体验',
        modal_content: '账号：T0002\n密码：Aa123456!\n\n400-9918-114'
      },
      svTargetUrl: 'http://web.appa.a111a.cn:6090/login/055/work.html'
    }
  },
  mounted() {
    // 如果已登录，启动心跳
    this.startHeartbeat()

    // 监听登录状态变化
    this.$root.$on('user-logged-in', () => {
      this.startHeartbeat()
      // 用户登录后预取用户相关数据
      dataPrefetcher.prefetchUserData()
    })

    this.$root.$on('user-logged-out', () => {
      this.stopHeartbeat()
      // 用户登出时清理预取缓存
      dataPrefetcher.clearPrefetchCache()
    })

    // 初始化鼠标跟随吉祥物
    this.initMouseFollower()

    // 注册Service Worker
    this.registerServiceWorker()

    // 初始化数据预取
    this.initDataPrefetch()

    // 设置全局加载状态监听
    this.setupLoadingListeners()

    // 全局接管所有页面的服务按钮，统一改为弹窗交互
    document.addEventListener('click', this.handleGlobalSvClick, true)
  },
  beforeDestroy() {
    this.stopHeartbeat()

    // 清理鼠标跟随事件监听器
    if (this._mouseMoveHandler) {
      document.removeEventListener('mousemove', this._mouseMoveHandler)
    }


    // 清理优化器资源
    apiOptimizer.destroy()
    loadingManager.destroy()

    // 清理加载状态监听器
    loadingManager.removeListener(this.loadingListener)

    document.removeEventListener('click', this.handleGlobalSvClick, true)
  },
  methods: {
    getCurrentSvUserId() {
      return this.$store?.getters?.['auth/user']?.id ||
        this.$store?.state?.auth?.user?.id ||
        null
    },
    async handleGlobalSvClick(event) {
      const target = event.target
      if (!target || typeof target.closest !== 'function') {
        return
      }

      const svButton = target.closest('.quick-button.sv-button')
      if (!svButton) {
        return
      }

      event.preventDefault()
      event.stopPropagation()
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation()
      }

      await this.openServiceModal()
    },
    async openServiceModal() {
      if (this.svModalLoading) {
        return
      }

      this.svModalVisible = true
      this.svModalLoading = true

      const userId = this.getCurrentSvUserId()

      try {
        const [configResult] = await Promise.allSettled([
          svClickAPI.getSvModalConfig(),
          svClickAPI.recordSvClick({
            user_id: userId ? String(userId) : null,
            user_agent: navigator.userAgent
          })
        ])

        if (configResult.status === 'fulfilled') {
          const data = configResult.value?.data || configResult.value || {}
          this.svModalConfig = {
            modal_title: data.modal_title || '企业数字化服务体验',
            modal_content: data.modal_content || '账号：T0002\n密码：Aa123456!\n\n400-9918-114'
          }
        }
      } catch (error) {
        console.error('加载服务弹窗配置失败:', error)
      } finally {
        this.svModalLoading = false
      }
    },
    closeServiceModal() {
      this.svModalVisible = false
    },
    goToSvServicePage() {
      const newWindow = window.open(this.svTargetUrl, '_blank')
      if (!newWindow) {
        window.location.href = this.svTargetUrl
      }
    },
    formatSvModalContent(content) {
      if (!content) {
        return ''
      }

      const hasHtmlTag = /<\/?[a-z][\s\S]*>/i.test(content)
      if (hasHtmlTag) {
        return content
      }

      return content
        .split('\n')
        .map(line => {
          if (!line.trim()) {
            return '<p><br></p>'
          }
          return `<p>${this.escapeHtml(line)}</p>`
        })
        .join('')
    },
    escapeHtml(text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    startHeartbeat() {
      // 检查是否登录
      const token = localStorage.getItem('token')
      if (!token) return
      
      // 清除旧的定时器
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer)
      }
      
      // 每5秒发送一次心跳（配合10秒在线阈值）
      this.heartbeatTimer = setInterval(async () => {
        // 每次发送心跳前再次检查token
        const token = localStorage.getItem('token')
        if (!token) {
          this.stopHeartbeat()
          return
        }
        
        try {
          await request.post('/auth/heartbeat')  // request会自动添加/api/前缀
          console.log('💓 心跳发送成功')
        } catch (error) {
          // 静默处理心跳错误，不显示到控制台
          // 如果心跳失败（如token过期），停止心跳
          if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            this.stopHeartbeat()
          }
        }
      }, 5000) // 5秒
      
      console.log('✅ 心跳检测已启动（每5秒）')
    },
    
    stopHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer)
        this.heartbeatTimer = null
        console.log('⏹ 心跳检测已停止')
      }
    },
    
    // 打开二维码模态框
    openEwmModal() {
      this.ewmModalVisible = true
      
      // 如果是第一次打开，显示加载提示
      if (this.isFirstTimeOpen) {
        this.iframeLoading = true
      }
    },
    
    // 关闭二维码模态框
    closeEwmModal() {
      this.ewmModalVisible = false
      this.iframeLoading = false
    },
    
    // iframe加载完成
    handleIframeLoad() {
      console.log('✅ 智能体iframe加载完成')
      // 延迟隐藏提示，确保用户能看到
      setTimeout(() => {
        this.iframeLoading = false
        this.isFirstTimeOpen = false
      }, 1000)
    },

    // 注册Service Worker
    registerServiceWorker() {
      if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
          navigator.serviceWorker.register('/sw.js')
            .then(registration => {
              console.log('✅ Service Worker registered:', registration.scope)

              // 监听Service Worker更新
              registration.addEventListener('updatefound', () => {
                const newWorker = registration.installing
                if (newWorker) {
                  newWorker.addEventListener('statechange', () => {
                    if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                      // 有新版本可用
                      this.showUpdateNotification()
                    }
                  })
                }
              })

              // 监听来自Service Worker的消息
              navigator.serviceWorker.addEventListener('message', event => {
                this.handleServiceWorkerMessage(event)
              })

            })
            .catch(error => {
              console.log('ℹ️ Service Worker registration skipped (file not found or not supported):', error.message)
              // 不显示错误，因为这是可选功能
            })
        })
      }
    },

    // 显示更新通知
    showUpdateNotification() {
      // 使用Element UI的MessageBox
      this.$confirm('发现新版本，是否立即刷新？', '版本更新', {
        confirmButtonText: '立即刷新',
        cancelButtonText: '稍后',
        type: 'info'
      }).then(() => {
        window.location.reload()
      }).catch(() => {
        // 用户选择稍后更新
      })
    },

    // 处理Service Worker消息
    handleServiceWorkerMessage(event) {
      switch (event.data.type) {
        case 'SYNC_COMPLETE':
          this.$message.success(`已同步 ${event.data.count} 条数据`)
          break
        default:
          console.log('Service Worker message:', event.data)
      }
    },

    // 初始化数据预取
    initDataPrefetch() {
      // 监听路由变化，进行智能预取
      this.$router.afterEach((to, from) => {
        // 预取目标页面的数据
        dataPrefetcher.prefetchByRoute(to)

        // 记录用户行为用于智能预测
        const userAction = {
          type: 'navigation',
          from: from.name,
          to: to.name,
          timestamp: Date.now()
        }

        // 基于路由变化进行智能预取
        dataPrefetcher.intelligentPrefetch(to, [userAction])
      })

      // 预取首页数据
      dataPrefetcher.prefetchHomeData()
      dataPrefetcher.prefetchCommonData()
    },

    // 设置全局加载状态监听
    setupLoadingListeners() {
      loadingManager.addListener((status) => {
        // 更新全局加载状态
        this.globalLoadingState = status

        // 可以在这里更新全局UI状态
        if (status.globalState) {
          // 显示全局加载指示器
          console.log('🔄 Global loading:', status.currentState?.message || '加载中...')
        }
      })
    },

    // 初始化鼠标跟随吉祥物
    initMouseFollower() {
      const follower = this.$refs.mouseFollower
      if (!follower) return

      // 鼠标移动事件处理器
      const handleMouseMove = (e) => {
        const mouseX = e.clientX
        const mouseY = e.clientY

        // 设置跟随元素的位置（鼠标右下角）
        follower.style.left = mouseX + 15 + 'px'  // 鼠标右侧15px
        follower.style.top = mouseY + 15 + 'px'   // 鼠标下方15px
      }

      // 添加鼠标移动事件监听
      document.addEventListener('mousemove', handleMouseMove)

      // 存储事件处理器引用以便后续清理
      this._mouseMoveHandler = handleMouseMove
    },

  }
}
</script>

<style>
@import './assets/styles.css';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 确保router-view区域能够自动填充剩余空间 */
#app > router-view {
  flex: 1;
}

/* 全局安全卫士按钮 - 固定在返回顶部按钮上方 */
.floating-logo {
  position: fixed;
  bottom: 90px;  /* 返回顶部按钮(bottom: 30px, height: 50px) + 间距10px = 90px */
  right: 30px;   /* 与返回顶部按钮对齐 */
  width: 80px;
  height: 80px;
  background: url('@/assets/imgs/1.gif') no-repeat center center;
  background-size: cover;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  cursor: pointer;  /* 改为pointer，不再可拖动 */
  z-index: 1001;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  text-decoration: none;
  user-select: none;
  /* 添加细细的荧光蓝色边框 */
  border: 2px solid rgba(64, 224, 255, 0.6);
  box-shadow: 
    0 0 8px rgba(64, 224, 255, 0.4),
    0 0 15px rgba(64, 224, 255, 0.2),
    inset 0 0 8px rgba(64, 224, 255, 0.1);
}

.floating-logo:hover {
  box-shadow: 
    0 0 12px rgba(64, 224, 255, 0.6),
    0 0 20px rgba(64, 224, 255, 0.4),
    0 6px 25px rgba(0, 0, 0, 0.3),
    inset 0 0 12px rgba(64, 224, 255, 0.2);
  border-color: rgba(64, 224, 255, 0.9);
  transform: translateY(-2px);  /* 添加悬停效果 */
}

.floating-logo i {
  transition: transform 0.3s ease;
  opacity: 0.8;
}

.floating-logo:hover i {
  transform: translateY(-2px);
  opacity: 1;
}

/* 响应式设计 - 与返回顶部按钮保持一致 */
@media (max-width: 1400px) and (min-width: 1200px) {
  .floating-logo {
    /* 跟随返回顶部按钮移到顶部 */
    bottom: auto;
    top: 240px;  /* 返回顶部按钮(top: 180px, height: 45px) + 间距15px = 240px */
    right: 10px;
    width: 70px;
    height: 70px;
  }
}

/* 小屏幕时回到原位置 */
@media (max-width: 1199px) {
  .floating-logo {
    bottom: 90px;
    right: 30px;
    width: 80px;
    height: 80px;
  }
}

/* 移动端进一步调整 */
@media (max-width: 768px) {
  .floating-logo {
    bottom: 80px;  /* 返回顶部按钮(bottom: 20px, height: 45px) + 间距15px = 80px */
    right: 20px;
    width: 65px;
    height: 65px;
    font-size: 16px;
  }
}


/* 鼠标跟随吉祥物样式 */
.mouse-follower-mascot {
  position: fixed;
  width: 30px;
  height: 30px;
  background: url('@/assets/imgs/5475e23d-5cc6-4f74-bf11-8037d94f6ed7.png') no-repeat center center;
  background-size: contain;
  border-radius: 50%;
  pointer-events: none; /* 不拦截鼠标事件 */
  z-index: 9998; /* 低于安全卫士按钮(9999)，高于轨迹 */
  transition: all 0.1s ease-out; /* 平滑跟随 */
  opacity: 0.8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.mouse-follower-mascot:hover {
  opacity: 1;
  transform: scale(1.1);
}

/* 二维码模态框样式 */
.ewm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.ewm-modal {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 1200px;
  height: 85vh;
  max-height: 800px;
  overflow: hidden;
  animation: slideUp 0.3s ease;
  display: flex;
  flex-direction: column;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ewm-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.ewm-modal-header h3 {
  margin: 0;
  font-size: 1.3rem;
  color: white;
}

.close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 1.5rem;
  color: white;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

.ewm-modal-content {
  flex: 1;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.chat-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* 首次加载提示样式 */
.loading-tip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 10;
  background: rgba(255, 255, 255, 0.95);
  padding: 30px 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.loading-tip i {
  font-size: 32px;
  color: #667eea;
  margin-bottom: 15px;
  display: block;
}

.loading-tip p {
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.ewm-modal-content {
  position: relative;
}

/* 全局把导航栏 SV 文案统一显示为“服务” */
.quick-button.sv-button .button-label {
  font-size: 0 !important;
}

.quick-button.sv-button .button-label::after {
  content: '服务';
  font-size: 11px;
}

/* 隐藏旧的 SV 抽屉/面板，统一改为全局弹窗 */
.quick-panel.sv-panel {
  display: none !important;
}

.service-modal-content {
  min-height: 120px;
}

.service-modal-body {
  color: #303133;
  font-size: 14px;
  line-height: 1.8;
  word-break: break-word;
}

.service-modal-body p {
  margin: 0 0 10px;
}

.service-modal-body p:last-child {
  margin-bottom: 0;
}

.service-modal-body img {
  max-width: 100%;
  height: auto;
}

@media (max-width: 768px) {
  .ewm-modal {
    width: 95%;
    height: 90vh;
    max-height: none;
  }
}
</style> 